import React from "react";
import { Lock } from "lucide-react";

// Publication-clarity notice (DoD 23). Club-Network requests are NEVER posted to
// a public marketplace — they go only to the chosen agents. This reassurance is
// shown at the point of sending (N3 create) and when contacting an agent about
// an anonymous request (N2 message modal), so the club always knows who sees it.
const COPY = {
  "n3-create": {
    title: "Private to the agents you choose",
    body: "This search request is sent only to the agents you select. It is never published to a public feed or shown to anyone else.",
  },
  "n2-message": {
    title: "This starts a private chat",
    body: "Your message goes directly to this agent. Nothing is posted publicly, and your club stays anonymous on the request until you choose to share more in the chat.",
  },
};

const PublicationNotice = ({ variant = "n3-create", className = "" }) => {
  const copy = COPY[variant] || COPY["n3-create"];
  return (
    <div
      className={`flex items-start gap-2.5 bg-[#F0F7FF] border border-[#D6E7FF] rounded-lg px-3.5 py-3 ${className}`}
    >
      <Lock className="w-4 h-4 text-[#2283FF] flex-none mt-0.5" aria-hidden="true" />
      <div className="flex flex-col gap-0.5">
        <span className="text-[12.5px] font-semibold text-[#1B6FE0]">{copy.title}</span>
        <span className="text-[12px] text-[#4B5563] leading-snug">{copy.body}</span>
      </div>
    </div>
  );
};

export default PublicationNotice;
